import axios from 'CanExConfig/axios'

const endpoint = id => `/api/candidate/profiles/${id}/session_metadata`

export const getCandidateProfileMetadata = async id => {
  const response = await axios(endpoint(id), {
    method: 'GET',
  })

  return response.data
}
